import { createElement } from "../21946.js";

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

var facebook_SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M6.39 14.47v-4.433H5.014V8H6.39v-.878c0-2.269 1.026-3.32 3.253-3.32.421 0 1.15.083 1.448.165v1.846a9 9 0 0 0-.77-.024c-1.094 0-1.516.413-1.516 1.49V8h2.18l-.374 2.037H8.808v4.581a6.667 6.667 0 1 0-2.419-.148"
  })));
};
/* export default */ const facebook = (facebook_SvgFacebook);
export default facebook;
